import { render } from "./AppSkeletonMessageMedia.vue?vue&type=template&id=5e088fba&scoped=true&ts=true"
import script from "./AppSkeletonMessageMedia.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonMessageMedia.vue?vue&type=script&lang=ts"

import "./AppSkeletonMessageMedia.vue?vue&type=style&index=0&id=5e088fba&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e088fba"]])

export default __exports__